<div class="species-combo">
    <span>{{ params.value.SpeciesCommonName }}</span><br />
    <span><i>{{ params.value.SpeciesScientificName }}</i></span>
</div>